import { render, staticRenderFns } from "./page-loading.vue?vue&type=template&id=c70bbf80&scoped=true&"
import script from "./page-loading.vue?vue&type=script&lang=js&"
export * from "./page-loading.vue?vue&type=script&lang=js&"
import style0 from "./page-loading.vue?vue&type=style&index=0&id=c70bbf80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70bbf80",
  null
  
)

export default component.exports